import { Instagram, Facebook } from "lucide-react";
const LOGO_URL = "/assets/img/lona-justpadel.webp";

export default function Footer() {
  return (
    <footer className="bg-[#070b14] border-t border-white/5 py-14" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img src={LOGO_URL} alt="Just Padel" width="1200" height="600" className="h-8 w-auto mb-5" />
            <p className="font-body text-sm text-white/50 leading-relaxed max-w-sm">O melhor clube de padel de Barcelos. Campos premium, academia e comunidade.</p>
            <div className="flex gap-3 mt-5">
              <a href="https://www.instagram.com/justpadelbarcelos" target="_blank" rel="noopener noreferrer" aria-label="Instagram do Just Padel Center" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-jp-lime/20 hover:text-jp-lime transition-all text-white/50" data-testid="footer-instagram"><Instagram size={14} /></a>
              <a href="https://www.facebook.com/justpadelcenter" target="_blank" rel="noopener noreferrer" aria-label="Facebook do Just Padel Center" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-jp-lime/20 hover:text-jp-lime transition-all text-white/50" data-testid="footer-facebook"><Facebook size={14} /></a>
            </div>
          </div>
          <div>
            <h3 className="font-body text-[11px] font-medium text-white/50 uppercase tracking-wider mb-5">Links</h3>
            <div className="flex flex-col gap-2.5">
              {[["Sobre", "#about"], ["Campos", "#features"], ["Torneios", "#tournaments"], ["Academia", "#academy"], ["Contactos", "#contacts"]].map(([l, h]) => (
                <a key={h} href={h} className="font-body text-sm text-white/50 hover:text-jp-lime transition-colors">{l}</a>
              ))}
            </div>
          </div>
          <div>
            <h3 className="font-body text-[11px] font-medium text-white/50 uppercase tracking-wider mb-5">Horário</h3>
            <div className="flex flex-col gap-2.5 font-body text-sm">
              {[["Seg-Sex", "09:00-02:00"], ["Fds e Feriados", "09:00-20:00"]].map(([d, h]) => (
                <div key={d} className="flex justify-between"><span className="text-white/50">{d}</span><span className="text-white/55">{h}</span></div>
              ))}
            </div>
          </div>
        </div>
        <div className="border-t border-white/5 mt-10 pt-8">
          <a href="https://prr.brilean.cloud/" target="_blank" rel="noopener noreferrer" className="block" data-testid="footer-logos-bar-link">
            <img
              src="/assets/img/barra-logos.webp"
              alt="Logotipos institucionais"
              width="2000" height="289"
              loading="lazy"
              className="w-full max-w-md mx-auto h-auto opacity-80 hover:opacity-100 transition-opacity"
              data-testid="footer-logos-bar"
            />
          </a>
        </div>
        <div className="border-t border-white/5 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
          <p className="font-body text-[11px] text-white/50">&copy; {new Date().getFullYear()} Just Padel Center. Barcelos.</p>
          <a href="/privacidade" className="font-body text-[11px] text-white/55 hover:text-jp-lime transition-colors" data-testid="footer-privacy-link">Política de Privacidade</a>
        </div>
      </div>
    </footer>
  );
}
